<div
    class="ticket-dropdown app-container"
    [@detailExpand]="isExpanded ? 'expanded' : 'collapsed'"
    [ngClass]="{
        'selection-won': ticketIsWon === 1,
        'selection-lost': ticketIsWon === 0
    }"
    *ngIf="isExpanded"
>
    <div class="dropdown-content app-content">
        <!-- Loading State -->
        <div
            *ngIf="loading"
            class="loading-state"
        >
            <mat-spinner [diameter]="24"></mat-spinner>
            <span>Učitavanje detalja tiketa...</span>
        </div>

        <!-- Error State -->
        <div
            *ngIf="error"
            class="error-state"
        >
            <mat-icon class="error-icon">error_outline</mat-icon>
            <span>{{ error }}</span>
            <button
                mat-button
                color="primary"
                (click)="onRetry.emit()"
                class="retry-button"
            >
                <mat-icon>refresh</mat-icon>
                Pokušaj ponovo
            </button>
        </div>

        <!-- Ticket Info -->
        <div
            *ngIf="ticketDetails && !loading"
            class="ticket-info"
        >
            <div class="ticket-header">
                <div class="ticket-id">
                    <span class="value">
                        {{ ticketRow?.ticketUuid }}
                    </span>
                    <button
                        mat-icon-button
                        [matTooltip]="'Kopiraj ID tiketa'"
                        class="copy-button"
                        (click)="copyTicketId()"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>

                <div class="ticket-status">
                    <span
                        class="status-badge"
                        [ngClass]="{
                            'status-won': ticketIsWon === 1,
                            'status-lost': ticketIsWon === 0,
                            'status-unknown':
                                ticketIsWon === null ||
                                ticketIsWon === undefined
                        }"
                    >
                        <mat-icon class="status-icon">
                            {{
                                ticketIsWon === 1
                                    ? 'check_circle'
                                    : ticketIsWon === 0
                                      ? 'cancel'
                                      : 'help_outline'
                            }}
                        </mat-icon>
                        <span class="status-text">
                            {{
                                ticketIsWon === 1
                                    ? 'Won'
                                    : ticketIsWon === 0
                                      ? 'Lost'
                                      : 'Unknown'
                            }}
                        </span>
                    </span>
                </div>
            </div>

            <div class="header-details">
                <div class="detail-group">
                    <div class="detail-item">
                        <span class="detail-label">User:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.session?.userUuid ||
                                ticketRow?.userUuid ||
                                '/'
                        }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Client:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.session?.clientUuid ||
                                ticketRow?.clientUuid ||
                                '/'
                        }}</span>
                    </div>
                </div>

                <div class="detail-group">
                    <div class="detail-item">
                        <span class="detail-label">Stake:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.stake
                                ? (parsedTicketDetails?.stake | number: '1.2-2')
                                : '/'
                        }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Potential Win:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.amount
                                ? (parsedTicketDetails?.amount
                                  | number: '1.2-2')
                                : '/'
                        }}</span>
                    </div>
                </div>

                <div class="detail-group">
                    <div class="detail-item">
                        <span class="detail-label">Total Odds:</span>
                        <span class="detail-value">{{
                            calculateTotalOdds()
                                ? (calculateTotalOdds() | number: '1.2-2')
                                : '/'
                        }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Selections:</span>
                        <span class="detail-value">{{
                            parsedSelections?.length || '/'
                        }}</span>
                    </div>
                </div>

                <div class="detail-group">
                    <div class="detail-item">
                        <span class="detail-label">Created:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.transactionTime
                                ? (parsedTicketDetails?.transactionTime
                                  | dateTimeZone
                                      : currentTimeZone
                                      : 'dd/MM/yyyy HH:mm')
                                : '/'
                        }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Last Access:</span>
                        <span class="detail-value">{{
                            parsedTicketDetails?.lastAccessTimestamp
                                ? (parsedTicketDetails?.lastAccessTimestamp
                                  | dateTimeZone
                                      : currentTimeZone
                                      : 'dd/MM/yyyy HH:mm')
                                : '/'
                        }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="parsedSelections?.length > 0"
            class="selections-section"
        >
            <div class="section-header">
                Selections ({{ parsedSelections.length }})
            </div>
            <div class="selections-container">
                <div
                    class="selection-card"
                    *ngFor="
                        let selection of parsedSelections;
                        trackBy: trackBySelection
                    "
                    [ngClass]="{
                        'selection-won': selection.isWon === 1,
                        'selection-lost': selection.isWon === 0
                    }"
                >
                    <div class="match-details">
                        <div class="match-header">
                            <span class="sport-badge">{{
                                getSportName(selection.sport)
                            }}</span>
                            <div class="match-title">
                                {{ selection.home || '/' }} vs
                                {{ selection.away || '/' }}
                            </div>
                        </div>

                        <div class="selection-description">
                            <div class="market-info">
                                <span class="market-label">Market:</span>
                                <span class="market-name">{{
                                    selection.market
                                }}</span>
                            </div>
                            <div class="selection-info">
                                <span class="selection-label">Selection:</span>
                                <span class="selection-name">{{
                                    selection.selection
                                }}</span>
                            </div>
                            <div
                                class="l-info"
                                *ngIf="selection?.L != null"
                            >
                                <span class="l-label">L:</span>
                                <span class="l-value">{{ selection.L }}</span>
                            </div>
                            <div
                                class="band-info"
                                *ngIf="getSelectionBend(selection)"
                            >
                                <span class="band-label">Band:</span>
                                <span class="band-value">{{
                                    getSelectionBend(selection)
                                }}</span>
                            </div>
                        </div>

                        <div class="odds-info">
                            <span class="odds-label">Odds:</span>
                            <span class="odds-value">{{
                                selection.ODD || selection.odd
                                    ? (selection.ODD || selection.odd
                                      | number: '1.2-2')
                                    : '/'
                            }}</span>
                        </div>
                    </div>

                    <div class="match-result">
                        <div class="score-line">
                            <span class="score-label">Score:</span>
                            <span class="score-value">{{
                                selection.formattedScore || '/'
                            }}</span>
                        </div>
                        <div
                            class="result-line"
                            *ngIf="selection.formattedDetails"
                        >
                            <span class="result-label">Result:</span>
                            <mat-chip-set class="result-chips">
                                <mat-chip
                                    *ngFor="
                                        let detail of selection.formattedDetails.split(
                                            ' | '
                                        )
                                    "
                                    class="result-chip"
                                >
                                    {{ detail }}
                                </mat-chip>
                            </mat-chip-set>
                        </div>
                        <div
                            class="goals-line"
                            *ngIf="
                                selection.formattedGoals &&
                                selection.formattedGoals.length > 0
                            "
                        >
                            <span class="goals-label">Goals:</span>
                            <mat-chip-set class="goals-chips">
                                <mat-chip
                                    *ngFor="
                                        let goal of selection.formattedGoals
                                    "
                                    class="goal-chip"
                                >
                                    {{ goal.minute }}' {{ goal.team }}
                                    {{ goal.phase }}
                                </mat-chip>
                            </mat-chip-set>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
